import { isEmpty } from 'lodash-es'

import { JoinType } from '@/entities/auth'
import {
  convertFormValuesToSignUpGuest,
  useSignUp,
  useSignUpGuestCompleteStore,
  useSignUpGuestStore,
} from '@/features/sign-up'
import { isNilOrEmptyString } from '@/shared/lib'

export const DIALOG = {
  PHONE_SUCCESS_DIALOG: 'PHONE_SUCCESS_DIALOG',
  PASSPORT_SUCCESS_DIALOG: 'PASSPORT_SUCCESS_DIALOG',
  PASSPORT_SUCCESS_ADMIN_DIALOG: 'PASSPORT_SUCCESS_ADMIN_DIALOG',
  PASSPORT_EXIT_CONFIRM_DIALOG: 'PASSPORT_EXIT_CONFIRM_DIALOG',
  EMAIL_EXIT_CONFIRM_DIALOG: 'EMAIL_EXIT_CONFIRM_DIALOG',
  PASSPORT_OCR_SUCCESS_DIALOG: 'PASSPORT_OCR_SUCCESS_DIALOG',
  PASSPORT_OCR_FAIL_DIALOG: 'PASSPORT_OCR_FAIL_DIALOG',
} as const

type DialogKey = (typeof DIALOG)[keyof typeof DIALOG]

export const useSignUpGuest = ({
  onSuccess,
}: {
  onSuccess: (dialog: DialogKey) => void
}) => {
  const actions = useSignUpGuestCompleteStore(state => state.actions)

  const { signUp } = useSignUp({
    joinType: JoinType.GUEST,
    onSuccess: ocrToken => {
      const { verification } = useSignUpGuestStore.getState()

      const isPassportVerified =
        !isEmpty(verification.contactNumber) &&
        !isEmpty(verification.passportImageUrl)

      actions.updateComplete({
        surveyAvailable: true,
        signUpCompleteTime: new Date().toISOString(),
        verificationType: isPassportVerified ? 'passport' : 'phone',
      })

      onSuccess(
        isPassportVerified
          ? isNilOrEmptyString(ocrToken)
            ? DIALOG.PASSPORT_SUCCESS_ADMIN_DIALOG
            : DIALOG.PASSPORT_SUCCESS_DIALOG
          : DIALOG.PHONE_SUCCESS_DIALOG,
      )
    },
  })

  const handleSignUp = () => {
    const signUpData = convertFormValuesToSignUpGuest()

    if (!signUpData) {
      return
    }

    signUp(signUpData)
  }

  return { handleSignUp }
}
